import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Delay is sometimes helpful if the component loads new content dynamically
    // especially with animations or third-party libraries
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant", // or "smooth" if you want animated scroll
      });
    }, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;